import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { SONAR_DATA_KEYS, getChartBaseColors } from '../../utils/chart';
import { getViewForChart, getVisibleEntriesForView } from '../../redux/sonar/sonarSelectors';
import { Panel } from '../../components/layout/layout';
import WithToolbarWrapper from '../with-toolbar-wrapper/WithToolbarWrapper';
import ViewRadioGroup from '../view-radio-group/ViewRadioGroup';
import ScatterChart from '../../components/charts/d3/scatter/ScatterChart';
import { SONAR_SECTIONS } from '../../constants';

const CHART_INDEX = 0;

function Relevance() {
  const { t } = useTranslation('sonar');

  const view = useSelector(getViewForChart(SONAR_SECTIONS.RELEVANCE, CHART_INDEX));
  const theme = useSelector((state) => state.global.theme);
  const BASE_COLORS = getChartBaseColors(theme);
  const domainEntries = useSelector(getVisibleEntriesForView(view));

  const radius = 12;

  //! TEMPORARY SOLUTION
  let tempDomainEntries = domainEntries;

  if (
    domainEntries.length &&
    (!domainEntries[0][SONAR_DATA_KEYS.RELEVANCE_BREADTH] || !domainEntries[0][SONAR_DATA_KEYS.RELEVANCE_STRENGTH])
  ) {
    tempDomainEntries = [];
  }

  return (
    <Panel>
      <WithToolbarWrapper>
        <ViewRadioGroup chartIndex={CHART_INDEX} section={SONAR_SECTIONS.RELEVANCE} />

        <ScatterChart
          data={tempDomainEntries}
          xLabel={t('breadth')}
          yLabe={t('strength')}
          dataKeys={[SONAR_DATA_KEYS.RELEVANCE_BREADTH, SONAR_DATA_KEYS.RELEVANCE_STRENGTH]}
          getColor={({ trend }) => getColor(trend, BASE_COLORS)}
          radius={radius}
        />
      </WithToolbarWrapper>
    </Panel>
  );
}

export default Relevance;

function getColor(trend, baseColors) {
  if (trend > 0.1) {
    return baseColors.GREEN;
  }
  if (trend < -0.1) {
    return baseColors.RED;
  }
  return baseColors.BLUE;
}
